import React from 'react'
import { graphql } from 'gatsby'
import Helmet from 'react-helmet'

import Layout from '../../layouts/layout'
// import Hero from '../components/hero'

const SoftwareDataSolutionsPage = ({ data }) => {
  return (
    <Layout>
      <Helmet
        title={'Software & Data Solutions | ' + data.siteTitle.siteMetadata.title}
        meta={[
          { name: 'description', content: 'Software & Data Solutions overriding description but not keywords.' }
        ]}
      />
      <div style={{margin: '90px auto', maxWidth: '92%'}}>
        <h1>Software & Data Solutions</h1>
        <p>Welcome to the software-data-solutions page.</p>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query {
    siteTitle: site {
      siteMetadata {
        title
      }
    }
  }
`

export default SoftwareDataSolutionsPage
